module.exports = __webpack_public_path__ + "static/media/2020-04-14_Recurring_Summary.837788ff.jpg";